"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBookingTypes = exports.getBookingOperatorWithEnabledFosterAPI = exports.getBookingOperatorById = void 0;
var _ramda = require("ramda");
var _helpers = require("./helpers");
var EMPTY_OBJECT = {};
var domain = function domain(_) {
  return _.external;
};
var getBookingOperators = (0, _ramda.pipe)(domain, (0, _ramda.prop)('bookignOperators'));
var getBookingOperatorById = exports.getBookingOperatorById = (0, _ramda.converge)(function (operatorsMap, id) {
  return operatorsMap[id] || EMPTY_OBJECT;
}, [getBookingOperators, function (_, _ref) {
  var operatorID = _ref.operatorID;
  return operatorID;
}]);
var getBookingType = (0, _ramda.pipe)(getBookingOperatorById, (0, _ramda.prop)('bookingType'));

/**
 * @function
 * @returns {{ isBookingByOperator: boolean, isBookingByOwn: boolean }}
 */
var getBookingTypes = exports.getBookingTypes = (0, _ramda.pipe)(getBookingType, (0, _ramda.applySpec)({
  isBookingByOperator: _helpers.getIsBookingByOperator,
  isBookingByOwn: _helpers.getIsBookingByOwn
}));
var getBookingOperatorWithEnabledFosterAPI = exports.getBookingOperatorWithEnabledFosterAPI = function getBookingOperatorWithEnabledFosterAPI(state, _ref2) {
  var operatorID = _ref2.operatorID;
  var _getBookingOperators = getBookingOperators(state),
    operator = _getBookingOperators[operatorID];
  return (operator === null || operator === void 0 ? void 0 : operator.fosterAPIParams) ? operator : null;
};